import { Product } from "../../../../models/domains/pbm/Benefit/product";
import { PageableResult } from "../../../../models/domains/paginator/pageable-result";
import { AbstractParser } from "../../parser";

export class SearchProductsByParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.TotalPerPages);
    pageableResult.setTotalItems(payload.Total);
    pageableResult.setItems(this.parseSimpleProducts(payload.Data));
    return pageableResult;
  }

  private parseSimpleProducts(payload: Array<any>): Array<Product> {
    const simpleProductList: Array<Product> = payload.map((item) => {
      const simpleProduct = new Product();
      simpleProduct.setProductKey(item.ProductKey.Value);
      simpleProduct.setEan(item.Ean.Value);
      simpleProduct.setProductName(item.ProductName);
      simpleProduct.setPresentation(item.Presentation);
      simpleProduct.setLaboratory(item.Laboratory);
      simpleProduct.setProductSubType(item.ProductSubType);
      return simpleProduct;
    });
    return simpleProductList;
  }
}
